import Vue from 'vue'
import '../../scss/layouts/events.scss'

// Plugins
import Vuex from 'vuex'
import store from '../vue/events/store/store'
import router from '../vue/events/router'
import i18n from '../vue/events/i18n'
import VueAxios from 'vue-axios'
import VCalendar from "v-calendar"
import vClickOutside from 'v-click-outside'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat);

// todo: Let's find a dynamic way to load locales
if (window.events_data.locale === 'ja'){
	require('dayjs/locale/ja');
	dayjs.locale('ja');
}

//Components
import App from '../vue/events/App.vue'

export const EventBus = new Vue();

export default function () {
	Vue.config.productionTip = false;
	Vue.config.devtools = true;

	Vue.use(
		Vuex,
		VueAxios,
		VCalendar,
		vClickOutside,
	);

	// Let Vue use Dayjs as well
	Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs });

	Vue.filter('capitalize', function (value) {
		if (!value) return '';
		value = value.toString();
		return value.charAt(0).toUpperCase() + value.slice(1)
	});

	Vue.filter('array_key', function (value) {
		if (!value) return ''
		value = value.toString()

		value = value.replace(/\s/g, "_")
		value = value.replace("+", "and")
		value = value.replace(/[^a-zA-Z0-9_+]+/g, "")

		return value.toLowerCase()
	});

	new Vue({
		el: '#events',
		router,
		store,
		i18n,
		data: {},
		render: h => h(App),
	})
}
